// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1655V","col":"styles_col__2ne8y","fulfillmentStatus":"styles_fulfillmentStatus__33yqn","emailCol":"styles_emailCol__2eo6G"};